/**
 * Subscription Slider - Alpine.js component
 * Usage: x-data="subscriptionSlider(id)"
 */
document.addEventListener("alpine:init", () => {
    Alpine.data("subscriptionSlider", (sliderId) => ({
        isOpen: false,
        email: "",
        dontShowAgain: false,
        selectedLanguages: [],
        storageKey: "sliderShown",
        id: sliderId,
        sliderElement: null,

        handleOpen(targetId) {
            if (!targetId || targetId === this.id) {
                this.isOpen = true;
                if (this.sliderElement) document.body.appendChild(this.sliderElement);
                if (window.innerWidth < 768) document.body.style.overflow = "hidden";
            }
        },

        initialize(autoOpen = false, showDelay = 500) {
            this.selectedLanguages = [];
            this.sliderElement = this.$el;

            const portalContainer = document.getElementById("slider-portal") || document.createElement("div");
            portalContainer.id = "slider-portal";
            document.body.appendChild(portalContainer);
            portalContainer.appendChild(this.sliderElement);

            // Make slider visible (but still translated out of view)
            this.sliderElement.style.display = "block";

            if (autoOpen && !this.hasBeenDismissed()) {
                setTimeout(() => {
                    this.isOpen = true;
                    if (window.innerWidth < 768) document.body.style.overflow = "hidden";
                }, showDelay);
            }
        },

        hasBeenDismissed() {
            return siteStorage.get(this.storageKey) === "true";
        },

        setDismissed(dismissed) {
            if (dismissed) {
                siteStorage.set(this.storageKey, "true");
            } else {
                localStorage.removeItem(this.storageKey);
            }
        },

        close() {
            this.isOpen = false;
            document.body.style.overflow = "";
            if (this.dontShowAgain) this.setDismissed(true);
        },

        async submitForm() {
            if (!this.email) return;
            try {
                console.log("Submitting:", { email: this.email, languages: this.selectedLanguages });
                this.close();
                this.setDismissed(true);
                this.email = "";
                this.selectedLanguages = [];
                this.dontShowAgain = false;
            } catch (error) {
                console.error("Failed to submit form:", error);
            }
        },

        reset() {
            this.setDismissed(false);
            this.isOpen = true;
            if (window.innerWidth < 768) document.body.style.overflow = "hidden";
            this.email = "";
            this.selectedLanguages = [];
            this.dontShowAgain = false;
        }
    }));
});
